// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".debug[data-v-7c55451f]{font-size:11px;margin-bottom:2em}.debug pre[data-v-7c55451f]{background:#0f111a;border-radius:6px;color:#eee;padding:1em}.debug pre code[data-v-7c55451f]{display:block;font-family:\"Fantasque Sans Mono\",\"Cascadia Mono\",monaco,consolas,monospace;font-size:13px;overflow:hidden;white-space:pre-wrap;word-break:break-word}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
